import i18next from 'i18next';

export const getAddressLabel = (addressQuantinty: number) => {
   const pluralRules = new Intl.PluralRules('pl-PL');
   const grammaticalNumber = pluralRules.select(addressQuantinty);
   switch (grammaticalNumber) {
      case 'one':
         return i18next.t('labels.address_one');
      case 'few':
         return i18next.t('labels.address_few');
      case 'many':
         return i18next.t('labels.address_many');
   }
};
